import React from 'react';
import classNameBind from 'classnames/bind';
import { withTranslation } from '../../../Translator';
import ActionList from '../../../ActionList';
import Button from '../../../Button';
import Spinner from '../../../Spinner';
import Popover from '../../../Popover';
import { TextField } from '../../../TextField';

import styles from './SegmentPickerInner.module.css';

const bindClasses = classNameBind.bind(styles);

const SegmentPickerInner = ({
  items,
  onItemSelected,
  onClick,
  onSearch,
  search,
  isLoading,
  canManage,
  t,
  dataId,
  favoriteOnClick,
}) => (
  <div className={bindClasses('wrapper')} data-ppuc-id={dataId}>
    <Popover.Section padding="narrow">
      <TextField
        icon="search"
        onChange={onSearch}
        value={search}
        clearable
        autoFocus
        name="segment-picker-search"
      />
    </Popover.Section>
    <Popover.Section fixedHeight>
      <div className={bindClasses('list-wrapper', { center: isLoading })}>
        {
          isLoading
            ? <Spinner className="medium" />
            : (
              <ActionList
                groups={[{
                  id: 1,
                  items: items.map((item, index) => ({ ...item, id: index })),
                }]}
                onItemSelected={onItemSelected}
                favoriteOnClick={favoriteOnClick}
              />
            )
        }
      </div>
    </Popover.Section>
    {canManage && (
      <Popover.Section padding="narrow">
        <Button
          text={t('SegmentPicker.manage-segments')}
          appearance="simple"
          onClick={onClick}
          fullWidth
          dataId={`${dataId}.manage`}
        />
      </Popover.Section>
    )}
  </div>
);

SegmentPickerInner.defaultProps = {
  dataId: 'SegmentPickerInner',
};

const withTranslate = withTranslation('components')(SegmentPickerInner);
withTranslate.displayName = 'SegmentPickerInner';

export default withTranslate;
